/**
 * Chat Navigator — single-session stack (no session list).
 *
 * The ChatScreen auto-resolves to the user's latest session
 * (or creates one on first use).
 */

import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { ChatScreen } from '../screens/chat/ChatScreen';
import type { DiscussSeed, ThesisCommand } from '../services/chatStream';

export type ChatNavigatorParamList = {
  ChatScreen: {
    sessionId?: string;
    initialMessage?: string;
    autoSend?: boolean;
    /** Structured seeding turn (spec §3.2 entry A): build_thesis from the
     * thesis forms / Feed 复盘, or build_profile from the ＋ menu — auto-sent
     * once on mount. Import never navigates — it docks files in the
     * conversation itself. */
    initialCommand?: ThesisCommand;
    /** A Feed row handed over as *context to discuss* (revamp §6.3, revised
     * 2026-10-09): the shell shows a pending card and holds the discuss_item
     * command until the user sends their first message. Never auto-fires. */
    discussSeed?: DiscussSeed;
  };
};

const Stack = createNativeStackNavigator<ChatNavigatorParamList>();

export function ChatNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="ChatScreen" component={ChatScreen} />
    </Stack.Navigator>
  );
}
